import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, X } from 'lucide-react';

const SortablePart = ({ part, partIndex, children, onRemovePart, onPartChange }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: `part-${partIndex}` });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="part-box">
      <div className="part-header">
        <div className="drag-handle" {...attributes} {...listeners}>
          <GripVertical size={16} />
        </div>
        <input
          type="text"
          value={part.name}
          onChange={(e) => onPartChange(partIndex, 'name', e.target.value)}
          className="form-control part-name"
          placeholder={`第 ${partIndex + 1} 部分名称`}
        />
        {onRemovePart && (
          <button
            type="button"
            onClick={() => onRemovePart(partIndex)}
            className="remove-part-btn"
          >
            <X size={16} />
          </button>
        )}
      </div>
      {children}
    </div>
  );
};

export default SortablePart;
